// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"650":"01446c1d","685":"1e6ba6d3","912":"51c36017"}[chunkId] + ".chunk.js";
};